import React, { useRef } from "react";
import { BsFillTelephoneOutboundFill } from "react-icons/bs";
import { MdAddLocationAlt } from "react-icons/md";
import { RiMailCheckFill } from "react-icons/ri";
import { TbWorldDown } from "react-icons/tb";
import { VscSend } from "react-icons/vsc";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_daz2c3s',  
      'template_v5s9cpk',  
      form.current,
      'lFEHKr4yiKDHPgaYi'    
    )
    .then((result) => {
        console.log(result.text);
        alert('Message sent successfully!');
    }, (error) => {
        console.log(error.text);
        alert('Failed to send the message, please try again.');
    });

    // Reset form fields after submission
    e.target.reset();
  };

  return (
    <div className="contact" id="contact">
      <h1 className="mainHeading">Contact Us</h1>
      <p className="mainPara">I'm at Your Service</p>
      <div className="contactBoxes">
        <div className="contactBox">
          <BsFillTelephoneOutboundFill className="callIcon" />
          <h3 className="callTitle">Phone</h3>
          <p className="callPara">+14157128195</p>
        </div>
        <div className="contactBox">
          <MdAddLocationAlt className="callIcon" />
          <h3 className="callTitle">Location</h3>
          <p className="callPara">San Francisco, CA</p>
        </div>
        <div className="contactBox">
          <RiMailCheckFill className="callIcon" />
          <h3 className="callTitle">Email</h3>
          <p className="callPara">Juanduque525@gmail.com</p>
        </div>
        <div className="contactBox">
          <TbWorldDown className="callIcon" />
          <h3 className="callTitle">Website</h3>
          <p className="callPara">domain.com</p>
        </div>
      </div>
      <h1 style={{ fontSize: "2.2rem" }} className="mainHeading">
        SEND ME A MAIL
      </h1>
      <p style={{ fontSize: "1.2rem" }} className="mainPara">
        I'm Responsive to Message
      </p>
      <div className="contactContent">
        <form ref={form} onSubmit={sendEmail} className="contactForm">
          <div className="formDiv">
            <label htmlFor="" className="formTag">
              Name
            </label>
            <input
              type="text"
              name="user_name" 
              className="formInput"
              placeholder="Enter Your Name"
              required
            />
          </div>
          <div className="formDiv">
            <label htmlFor="" className="formTag">
              Email
            </label>
            <input
              type="email"
              name="user_email"
              className="formInput"
              placeholder="Enter Your Email"
              required
            />
          </div>
          <div className="formDiv formArea">
            <label htmlFor="" className="formTag">
              Message
            </label>
            <textarea
              name="message"
              cols="30"
              rows="10"
              className="formInput"
              placeholder="Enter Your Message"
              required
            ></textarea>
          </div>
          <div className="headBtn contactBtn" style={{ marginLeft: 0 }}>
            <button
              className="mainBtn animate__animated animate__fadeInUp"
              type="submit"
            >
              Send
              <VscSend className="btnSpan" style={{ marginBottom: "2px" }} />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
